var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_vm._v("\n    "+_vm._s(_vm.msg)+" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.a)),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.a+=1}}},[_vm._v("点击")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3733fd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test.vue
// module id = null
// module chunks = 